import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';

import { IdentityClaims } from './models/identity-claims.model';

import * as LoginActions from '../shared/state-management/actions/login';
import * as RouterActions from '../shared/state-management/actions/router';
import { IsUserLoggedIn } from '../shared/state-management/reducers/login';

@Injectable()
export class LoginGuard implements CanActivate {

	constructor(private oauthService: OAuthService, private store: Store<{}>) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const hasIdToken = this.oauthService.hasValidIdToken();
		const hasAccessToken = this.oauthService.hasValidAccessToken();
		const allowed: boolean = (hasIdToken && hasAccessToken);

		if (allowed) {
			this.store.select(IsUserLoggedIn).take(1).subscribe(loggedIn => {
				if (!loggedIn) {
					const claims = this.oauthService.getIdentityClaims();
					this.store.dispatch(new LoginActions.LoginSuccessful(claims as IdentityClaims));
				}
			});
		} else {
			this.store.dispatch(new RouterActions.Go({path: ['/login'], query: {target: state.url.toString()}}));
		}

		return allowed;
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.guard.ts